import { Filter } from '../../../workbook';
import { Dashboard } from '../../models';

export function removeDuplicateFilters(boardInfo: Dashboard) {
  const filters: Filter[] = boardInfo.configuration.filters;
  if (filters) {
    boardInfo.configuration.filters = filters.reduce((acc: Filter[], curr: Filter) => {
      if (!acc.some((item) => item.dataSource === curr.dataSource && item.field === curr.field)) {
        acc.push(curr);
      }

      return acc;
    }, []);
  }
}
